import { CircleCheck, CircleAlert, Info, X } from 'lucide-react';
import { useToasts } from '@/store/ui';
import { cn } from '@/lib/cn';

export function Toaster() {
  const { toasts, dismiss } = useToasts();
  return (
    <div aria-live="polite" className="pointer-events-none fixed inset-x-4 bottom-4 z-[60] flex flex-col items-end gap-2 sm:left-auto sm:right-4 sm:w-96">
      {toasts.map((t) => (
        <div key={t.id} role={t.tone === 'error' ? 'alert' : 'status'} className="pointer-events-auto flex w-full items-start gap-3 rounded-xl border border-line bg-surface p-3 shadow-lg">
          <span className={cn('mt-0.5', t.tone === 'success' ? 'text-success' : t.tone === 'error' ? 'text-danger' : 'text-info')}>
            {t.tone === 'success' ? <CircleCheck className="h-4 w-4" /> : t.tone === 'error' ? <CircleAlert className="h-4 w-4" /> : <Info className="h-4 w-4" />}
          </span>
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium text-ink">{t.title}</p>
            {t.body && <p className="mt-0.5 text-sm text-ink-muted">{t.body}</p>}
          </div>
          <button type="button" onClick={() => dismiss(t.id)} className="text-ink-subtle hover:text-ink" aria-label="Dismiss"><X className="h-4 w-4" /></button>
        </div>
      ))}
    </div>
  );
}
